import { yupResolver } from '@hookform/resolvers/yup';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { Fab } from '@mui/material';
import { Box } from '@mui/system';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { FormTextField } from '../../common/form';
import { CreateProductCategoryDto, ProductCategoryDto } from '../../common/PricePrgClient';
import {
    createProductCategory,
    deleteProductCategory,
    updateProductCategory
} from '../product/redux/productSlices';
import { showConfirmDialog } from '../ui/redux/uiSlices';
type Props = {
    productCategory: ProductCategoryDto;
    disabled: boolean;
};

const schema: yup.SchemaOf<CreateProductCategoryDto> = yup.object().shape({
    name: yup.string().required().max(60).label('Name'),
    externalIdentifier: yup.string().optional().max(40).label('External identifier'),
    level: yup.number().min(1).max(2).required().label('Level')
});
export const ProductCategoryRow = ({ productCategory, disabled }: Props) => {
    const dispatch = useDispatch();
    const { handleSubmit, control } = useForm<CreateProductCategoryDto>({
        resolver: yupResolver(schema),
        defaultValues: productCategory
    });

    const onSubmit = (request: CreateProductCategoryDto) => {
        if (!productCategory.productCategoryId) {
            dispatch(createProductCategory.request(request));
        } else {
            dispatch(
                updateProductCategory.request({
                    ...request,
                    productCategoryId: productCategory.productCategoryId
                })
            );
        }
    };

    const handleDelete = () => {
        dispatch(
            showConfirmDialog({
                dialogMessage: 'Do you want to delete the product category?',
                dialogTitle: 'Delete product category',
                okAction: deleteProductCategory.request(productCategory.productCategoryId),
                primaryActionName: 'Delete'
            })
        );
    };

    return (
        <Box>
            <FormTextField
                sx={{ padding: 1 }}
                label="Name"
                control={control}
                name="name"
                disabled={disabled}
            />
            <FormTextField
                sx={{ padding: 1 }}
                control={control}
                name="externalIdentifier"
                disabled={disabled}
                label="External Id"
            />
            <FormTextField
                sx={{ padding: 1 }}
                control={control}
                name="level"
                type="number"
                disabled={disabled}
                label="Level"
            />
            <Fab
                sx={{ mt: 2 }}
                size="small"
                color="primary"
                disabled={disabled}
                onClick={handleSubmit(onSubmit)}
            >
                <SaveIcon />
            </Fab>
            <Fab sx={{ mt: 2 }} size="small" color="error" disabled={disabled} onClick={handleDelete}>
                <DeleteIcon />
            </Fab>
        </Box>
    );
};
